import Parser from "html-react-parser";
import fillTemplate from "@js/fillTemplate";

const round = (x) => Math.round(x);
const pow = (x, n) => Math.pow(x, n);

export function roundedpercent(x, Ndecimals = 0) {
  //for example, if Ndecimals is 1, then displays 0.0314159 as 3.1
  //round(100*x*10^n)/10^n
  return round(100 * x * pow(10, Ndecimals)) / pow(10, Ndecimals);
}

export function roundn(x, Ndecimals = 0) {
  //for example, if Ndecimals is 1, then displays 3.14159 as 3.1
  //round(x*10^n)/10^n
  return round(x * pow(10, Ndecimals)) / pow(10, Ndecimals);
}

export function sum0(v) {
  return v.reduce((a, b) => a + b, 0);
}

export function scroll(ref) {
  window.scrollTo({ behavior: "smooth", top: ref.current.offsetTop - 70 });
}

export function pretty(tons) {
  if (tons < 1) {
    return spacednumber(Math.round(tons * 1000)) + ' kg'
  } else {
    return spacednumber(Math.round(tons)) + ' ton'
  }
}

export function spacednumber(x) {
  //for example, displays 1406382 as 1 406 382
  return round(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function signednumber(x) {
  //add a plus for positive numbers (return string)
  return x < 0 ? `${x}` : `+${x}`;
}

export function indexarray(N, offset = 0) {
  let v = Array.from(Array(N).keys()); //0,1,2,...,N-1
  for (let i = 0; i < v.length; i++) {
    v[i] += offset;
  }
  return v;
}

export function debounce(fn, ms) {
  //only call fn if it has not been called in the last ms interval
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

export function specialheight(containerwidth, windowheight, plot_aspectratio) {
  //If we want aspect of plot to be 21:9 and be at bottom of screen,
  //then put other stuff in a box with remaining height
  let plotheight = containerwidth / plot_aspectratio;
  //let h = windowheight - 225; //subtract some for topmenu et al.
  let h = windowheight - 250;
  let remainingheight = h - plotheight;
  return round(remainingheight);
}

export function richtext(content) {
  return content ? Parser(content.childContentfulRichText.html) : null;
}

export function richtextTemplate(content, ctx) {
  return content ? richtext(fillTemplate(content, ctx)) : null;
}

export function shortname(name) {
  const short = {
    "Personbilar (ägarutsläpp)": "Personbilar",
    "Övriga inrikes transporter": "Transporter",
    //"Utrikes sjöfart": "Sjöfart",
    //"Utrikes flyg": "Flyg",
    "Egen uppvärmning av bostäder och lokaler": "Uppvärming",
    "Produktanvändning (inkl. lösningsmedel)": "Produktanvändning",
  };
  if (name in short) {
    return short[name];
  } else {
    return name;
  }
}

export function sgenitiv(name, strict = false) {
  const letters = strict
    ? ["s", "a", "e", "i", "o", "u", "y", "å", "ä", "ö"]
    : ["s"];

  const lastchar = name[name.length - 1];
  if (letters.includes(lastchar)) {
    return `${name}`;
  } else {
    return `${name}s`;
  }
}

// mutates x
export function nestedfilter(x, condition) {
  if (typeof x !== "object" || x == null || Array.isArray(x)) return x;

  for (const k in x) {
    if (!condition(x[k])) delete x[k];
    else x[k] = nestedfilter(x[k], condition);
  }

  return x;
}

export function isNonEmpty(x) {
  return !isEmpty(x);
}

export function isEmpty(x) {
  // TODO replace with _.isEmpty()
  if (typeof x !== "object" && typeof x !== "string") return false;
  for (const k in x) return false;
  return true;
}

export function nestedObjectAssign(x, y) {
  // return 'y' if _either_ of 'x' or 'y' isn't a nested object
  if (typeof x !== "object" || x == null || Array.isArray(x)) return y;
  if (typeof y !== "object" || y == null || Array.isArray(y)) return y;

  for (const k in y) {
    x[k] = nestedObjectAssign(x[k], y[k]);
  }

  return x;
}

export function deepCopy(x) {
  return JSON.parse(JSON.stringify(x));
}

export function padwithlast(arr, n) {
  //
  let x = arr[arr.length - 1];
  for (let i = 0; i < n; i++) {
    arr.push(x);
  }
  return arr;
}

export function copy(v) {
  return v.slice(0);
}
